<template>
<div class="chapter">
<div class="inner_page">
<h2 class="ph">II.</h2>
<p class="calibre3">Port Admiral Haynes, newly chosen President of the Galactic Council
and by virtue of his double office probably the most powerful being in
the First Galaxy, set instantly into motion the vast machinery which
would make Tellus safe against any possible attack. He first called
together his Board of Strategy; the same keen-minded tacticians who had
helped him plan the invasion of the Second Galaxy and the eminently
successful attack upon Jarnevon. Should Grand Fleet, many of whose
component fleets had not yet reached their home planets, be recalled?
Not yet—lots of time for that. Let them go home for a while first. The
enemy would have to rebuild before they could attack, and there were
many more pressing matters.</p>
<p class="calibre3">Scouting was most important. The planets near the galactic rim could
take care of that. In fact, they should concentrate upon it, to the
exclusion of everything else of warfare's activities. Every approach to
the Galaxy—yes, the space between the two galaxies and as far into the
Second Galaxy as it was safe to penetrate—should be covered as with a
blanket. That way, they could not be surprised.</p>
<p class="calibre3">Kinnison, when he heard that, became vaguely uneasy. He did not really
have a thought; it was as though he should have had one, but didn't.
Deep down, far off, just barely above the threshold of perception an
indefinite, formless something obtruded itself upon his consciousness.
Tug and haul at it as he would, he could not get the drift. There
was <i class="calibre9">something</i> he ought to be thinking of, but what in all the
iridescent hells from Vandemar to Alsakan was it? So, instead of
flitting about upon his declared business, he stuck around; helping the
General Staff—and thinking.</p>
<p class="calibre3">And Defense Plan GBT went from the idea men to the draftsmen, then to
the engineers. This was to be, primarily, a war of planets. Ships could
battle ships, fleets fleets; but, postulating good tactics upon the
other side, no fleet, however armed and powered, could stop a planet.
That had been proved. A planet had a mass of the order of magnitude of
one times ten to the twenty-fifth kilogram, and an intrinsic velocity
of somewhere around forty kilometers per second. A hundred probably,
relative to Tellus, if the planet came from the Second Galaxy. Kinetic
energy, roughly, about five times ten to the forty-first ergs. No, that
was nothing for any possible fleet to cope with.</p>
<p class="calibre3">Also, the attacking planets would of course be inertialess until the
last strategic instant. Very well, they must be made inert prematurely,
when the Patrol wanted them that way, not the enemy. How? The
Bergenholms upon those planets would be guarded with everything the
Boskonians had.</p>
<p class="calibre3">The answer to that question, as worked out by the engineers, was
something they called a "super-mauler." It was gigantic, cumbersome
and slow; but little faster, indeed, than a free planet. It was
like Helmuth's fortresses of space, only larger. It was like the
special defense cruisers of the Patrol, except that its screens were
vastly heavier. It was like a regular mauler, except that it had
only one weapon. All of its incomprehensible mass was devoted to one
thing—<i class="calibre9">power</i>! It could defend itself; and, if it could get close
enough to its objective, it could do plenty of damage—its dreadful
primary was the first weapon ever developed capable of cutting a Q-type
helix squarely in two.</p>
<p class="calibre3">And in various solar systems, uninhabitable and worthless planets were
converted into projectiles. Dozens of them, possessing widely varying
masses and intrinsic velocities. One by one they flitted away from
their parent suns and took up positions—not too far away from our
Solar System, but not too near.</p>
<p class="calibre3">And finally Kinnison, worrying at his tantalizing thought as a dog
worries a bone, crystallized it. Prosaically enough, it was an
extremely short and flamboyantly waggling pink shirt which catalyzed
the reaction; which acted as the seed of the crystallization. Pink—a
Chickladorian—Xylpic the Navigator—Overlords of Delgon. Thus flashed
the train of thought, culminating in:</p>
<p class="calibre3">"Oh, so <i class="calibre9">that's</i> it!" he exclaimed, aloud. "That's IT, as sure as
hell's a man trap!" He whistled raucously at a taxi, took the wheel
himself, and broke—or at least bent—most of the city's traffic
ordinances in getting to Haynes' office.</p>
<p class="calibre3">The port admiral was always busy, but he was never too busy to see Gray
Lensman Kinnison; especially when the latter demanded the right of way
in such terms as he used then.</p>
<p class="calibre3">"The whole defense set-up is screwy," Kinnison stated, baldly
and at once. "I thought from the first that I was overlooking a
bet, but I couldn't locate it. Why should they fight their way
through intergalactic space and through sixty thousand parsecs of
planet-infested galaxy when they don't have to?" he demanded. "Think
of the length of the supply line, with our bases placed to cut it in
a hundred places, no matter how they route it. It doesn't make sense.
They'd have to outweigh us in an almost impossibly high ratio, unless
they have an improbably superior armament."</p>
<p class="calibre3">"Check." The old warrior was entirely unperturbed. "Surprised that you
didn't see that long ago. We did. We do not believe that they are going
to attack at all."</p>
<p class="calibre3">"But you're going ahead with all this just as though—"</p>
<p class="calibre3">"Certainly. Something <i class="calibre9">may</i> happen, and we can't be caught off
guard. Besides, it's good training for the boys. Helps morale, no end."
Haynes' nonchalant air disappeared and he studied the younger man
keenly for moments. "But Mentor's warning certainly meant something,
and you said 'when they don't have to.' But even if they go clear
around the Galaxy to the other side—an impossibly long haul—we're
covered. Tellus is near enough to the center of this galaxy so that
they can't possibly take us by surprise. So—spill it!"</p>
<p class="calibre3">"How about a hyperspatial tube? They know exactly where we are, you
know."</p>
<p class="calibre3">"Hm-m-m!" Haynes was taken aback. "Never thought of it—possible,
distinctly a possibility. A duodec bomb, say, just far enough
underground—"</p>
<p class="calibre3">"Nobody else thought of it, either, until just now," Kinnison broke in.
"However, I'm not afraid of duodec—don't see how they could control
it accurately enough at this three-dimensional distance. Too deep, it
wouldn't explode at all. What I don't like to think of, though, is a
negasphere. Or a planet, perhaps."</p>
<p class="calibre3">"Ideas? Suggestions?" the admiral snapped.</p>
<p class="calibre3">"No—I don't know anything about the stuff. How about putting our
Lenses on Cardynge?"</p>
<p class="calibre3">"That's a thought!" and in seconds they were in communication with Sir
Austin Cardynge, Earth's mightiest mathematical brain.</p>
<p class="calibre3">"Kinnison, how many times must I tell you that I am not to be
interrupted?" the aged scientist's thought was a crackle of fury. "How
can I concentrate upon vital problems if every young whippersnapper
in the System is to perpetrate such abominable, such outrageous
intrusions—"</p>
<p class="calibre3">"Hold it, Sir Austin—hold everything!" Kinnison soothed. "I'm sorry. I
wouldn't have intruded if it hadn't been a matter of life or death. But
it would be a worse intrusion, wouldn't it, if the Boskonians sent a
planet about the size of Jupiter—or a negasphere—through one of their
extradimensional vortices into your study? That's exactly what they're
figuring on doing."</p>
<p class="calibre3">"What ... what ... what?" Cardynge snapped, like a string of
firecrackers. He quieted down, then, and thought. And Sir Austin
Cardynge <i class="calibre9">could</i> think, upon occasion and when he felt so
inclined; could think in the abstruse symbology of pure mathematics
with a cogency equaled by few minds in the Universe. Both Lensmen
perceived those thoughts, but neither could understand or follow them.
No mind not a member of the Conference of Scientists could have done so.</p>
<p class="calibre3">"They can't!" of a sudden the mathematician cackled, gleefully
disdainful. "Impossible—quite definitely impossible. There are
laws governing such things, Kinnison, my impetuous and ignorant
young friend. The terminus of the necessary hypertube could not be
established within such proximity to the mass of the Sun. This is shown
by—"</p>
<p class="calibre3">"Never mind the proof—the fact is enough," Kinnison interposed,
hastily. "How close to the Sun could it be established?"</p>
<p class="calibre3">"I couldn't say, offhand," came the cautiously scientific reply. "More
than two astronomical units, certainly, but the computation of the
exact distance would require some little time. It would, however, be an
interesting, if minor, problem. I will solve it for you, if you like,
and advise you of the exact minimum distance."</p>
<p class="calibre3">"Please do so—thanks a million," and the Lensmen disconnected.</p>
<p class="calibre3">"The conceited old goat!" Haynes snorted. "I'd like to smack him down!"</p>
<p class="calibre3">"I've felt like it more than once, but it wouldn't do any good.
You've got to handle him with gloves—besides, you can afford to make
concessions to a man with a brain like that."</p>
<p class="calibre3">"I suppose so. But how about that infernal tube? Knowing that it cannot
be set up within or very near Tellus helps some, but not enough. We've
got to know where it is—<i class="calibre9">if</i> it is. Can you detect it?"</p>
<p class="calibre3">"Yes. That is, I can't, but the specialists can, I think. Wise of Medon
would know more about that than anyone else. Why wouldn't it be a
thought to call him over here?"</p>
<p class="calibre3">"It would that;" and it was done.</p>
<p class="calibre3">Wise of Medon and his staff came, conferred and departed.</p>
<p class="calibre3">Sir Austin Cardynge solved his minor problem, reporting that the
minimum distance from the Sun's center to the postulated center of
the terminus of the vortex—actually, the geometrical origin of the
three-dimensional figure which was the hyperplane of intersection—was
three point two six four seven, approximately, astronomical units;
the last figure being tentative and somewhat uncertain because of the
rapidly moving masses of Jupiter—</p>
<p class="calibre3">"Cover everything beyond three units out in every direction," Haynes
directed, when he got that far along the tape. He had no time to
listen to an hour of mathematical dissertation. What he wanted was
<i class="calibre9">facts</i>.</p>
<p class="calibre3">Shortly thereafter, five-man speedsters, plentifully equipped with new
instruments, flashed at full drive along courses carefully calculated
to give the greatest possible coverage in the shortest possible time.</p>
<p class="calibre3">Unobtrusively the loose planets closed in upon the Solar System. Not
close enough to affect appreciably the orbits of Sol's own children,
but close enough so that at least three or four of them could reach
any designated point in one minute or less. And the outlying units
of Grand Fleet, too, were pulled in. That fleet was not actually
mobilized—yet—but every vessel in it was kept in readiness for
instant action.</p>
<p class="calibre3">"No trace," came the report from the Medonian surveyors, and Haynes
looked at Kinnison, quizzically.</p>
<p class="calibre3">"QX, chief—glad of it," the Gray Lensman answered the unspoken
query. "If it was up, that would mean that they were on the way. Hope
they don't get a trace for two months yet. But I'm next to positive
that that's the way they're coming and the longer they put it off
the better—there's a possible new projector that will take a bit of
doping out. I've got to do a flit—can I have the <i class="calibre9">Dauntless</i>?"</p>
<p class="calibre3">"Sure—anything you want. She's yours, anyway."</p>
<p class="calibre3">Kinnison went. And, wonder of wonders, he took Sir Austin Cardynge
with him. From solar system to solar system, from planet to planet,
the mighty <i class="calibre9">Dauntless</i> hurtled at the incomprehensible velocity
of her full maximum blast; and every planet so visited was the home
world of one of the most co-operative—or, more accurately, one of the
least non-co-operative—members of the Conference of Scientists. For
days brilliant but more or less unstable minds struggled with new and
obdurate problems; struggled heatedly and with friction, as was their
wont. Few, if any, of those mighty intellects would have really enjoyed
a quietly studious session, even had such a thing been possible.</p>
<p class="calibre3">Then Kinnison returned his guests to their respective homes and shot
his flying warship-laboratory back to Prime Base. And, even before
the <i class="calibre9">Dauntless</i> landed, the first few hundreds of a fleet which
was soon to be numbered in the millions of meteor miners' boats began
working like beavers to build a new and exactly designed system of
asteroid belts of iron meteors.</p>
<p class="calibre3">And soon, as such things go, new structures began to appear here and
there in the void. Comparatively small, these things were; tiny, in
fact, compared to the Patrol's maulers. Unarmed, too; carrying nothing
except defensive screen. Each was, apparently, simply a powerhouse;
stuffed skin full of atomic motors, exciters, intakes and generators of
highly peculiar design and pattern. Unnoticed except by gauntly haggard
Thorndyke and his experts, who kept dashing from one of the strange
craft to another, each took its place in a succession of precisely
determined relationships to the Sun.</p>
<p class="calibre3">Between the orbits of Mars and of Jupiter, the new, sharply defined
rings of asteroids moved smoothly. Grand Fleet formed an enormous
hollow globe, six astronomical units in diameter. Outside that globe
the surveying speedsters and flitters rushed madly hither and yon.
Uselessly, apparently, for not one needle of the vortex detectors
stirred from its zero pin.</p>
<p class="calibre3">And as nearly as possible at the center of that globe, circling the
Sun well inside the orbit of Venus, there floated the flagship.
Technically the <i class="calibre9">Z9M9Z</i>, socially the <i class="calibre9">Directrix</i>, ordinarily
simply <i class="calibre9">GFHQ</i>, that ship had been built specifically to control
the operations of a million separate flotillas. At her million-plug
board stood—they had no need, ever, to sit—two hundred blocky,
tentacle-armed Rigellians. They were waiting, stolidly motionless.</p>
<p class="calibre3">Intergalactic space remained empty. Interstellar ditto, ditto. The
flitters flitted, fruitlessly.</p>
<p class="calibre3">But if everything out there in the threatened volume of space seemed
quiet and serene, things in the <i class="calibre9">Z9M9Z</i> were distinctly otherwise.
Haynes and Kinnison, upon whom the heaviest responsibilities rested,
were tensely ill at ease.</p>
<p class="calibre3">The admiral had his formation made, but he did not like it at all.
It was too big, too loose, too cumbersome. The Boskonian fleet might
appear anywhere outside that thin globe of Patrol ships, and it would
take him far, far too long to get any kind of a fighting formation
made, anywhere. So he worried. Minutes dragged—he wished that the
pirates would hurry up and start something!</p>
<p class="calibre3">Kinnison was even less easy in his mind. He was not afraid of
negaspheres, even if Boskonia should have them; but he was afraid of
fortified, mobile planets. The supermaulers were big and powerful, of
course, but they very definitely were not planets; and the big, new
idea was mighty hard to jell. He did not like to bother Thorndyke by
calling him—the master technician had troubles of his own—but the
reports that were coming in were none too cheery. The excitation was
wrong or the grid action was too unstable or the screen potentials were
too high or too low or something. Sometimes they got a concentration,
but it was just as apt as not to be a spread flood instead of a tight
beam. To Kinnison, therefore, the minutes fled like seconds—but every
minute that space remained clear was one more precious minute gained.</p>
<p class="calibre3">Then, suddenly, it happened. A needle leaped into significant figures.
Relays clicked, a bright red light flared into being, a gong clanged
out its raucous warning. A fractional instant later ten thousand
other gongs in ten thousand other ships came brazenly to life as the
discovering speedster automatically sent out its number and position;
and those other ships—surveyors all—flashed toward that position and
dashed frantically about. Theirs the task to determine, in the least
number of seconds possible, the approximate location of the center of
emergence.</p>
<p class="calibre3">For Port Admiral Haynes, canny old tactician that he was, had planned
his campaign long since. It was standing plain in his tactical tank—to
inglobe the entire space of emergence of the foe and to blast them out
of existence before they could maneuver. If he could get into formation
before the Boskonians appeared, it would be a simple slaughter—if
not, it might be otherwise. Hence seconds counted; and hence he had had
high-speed computers working steadily for weeks at the computation of
courses for every possible center of emergence.</p>
<p class="calibre3">"Get me that center—fast!" Haynes barked at the surveyors, already
blasting at maximum.</p>
<p class="calibre3">It came in. The chief computer yelped a string of numbers. Selected
loose-leaf binders were pulled down, yanked apart, and distributed on
the double, leaf by leaf. And:</p>
<p class="calibre3">"Get it over there! Especially the shock globe!" the port admiral
yelled.</p>
<div class="figcenter2" id="illus4">
<img alt="" class="w" id="id-6628567251534143176" src="Images/img0012.jpg"/>
</div>
<p class="calibre3">For he himself could direct the engagement only in broad; details
must be left to others. To be big enough to hold in any significant
relationship the millions of lights representing vessels, fleets,
planets, structures and objectives, the Operations tank of the
<i class="calibre9">Directrix</i> had to be seven hundred feet in diameter; and it was a
sheer physical impossibility for any ordinary mind either to perceive
that seventeen million cubic feet of space as a whole or to make any
sense at all out of the stupendously bewildering maze of multicolored
lights crawling and flashing therein.</p>
<p class="calibre3">Kinnison and Worsel had handled Grand Fleet Operations during the
Battle of Jarnevon, but they had discovered that they could have used
some help. Four Rigellian Lensmen had been training for months for that
all-important job, but they were not yet ready. Therefore the two old
masters and one new one now labored at GFO: three tremendous minds,
each supplying something that the others lacked. Kinnison of Tellus,
with his hard, flat driving urge, his unconquerable, unstoppable will
to do. Worsel of Velantia, with the prodigious reach and grasp which
had enabled him, even without the Lens, to scan mentally a solar system
eleven light-years distant. Tregonsee of Rigel IV, with the vast, calm
certainty, the imperturbable poise peculiar to his long-lived, solemn
race. Unattached Lensmen all; minds linked, basically, together into
one mind by a wide-open three-way, superficially free, each to do his
assigned third of the gigantic task.</p>
<p class="calibre3">Smoothly, effortlessly, those three linked minds went to work at the
admiral's signal. Orders shot out along tight beams of thought to the
stolid hundreds of Rigellian switchboard operators, and thence along
communicator beams to the pilot rooms, wherever stationed. Flotillas,
squadrons, subfleets flashed smoothly toward their newly assigned
positions. Supermaulers moved ponderously toward theirs. The survey
ships, their work done, vanished. They had no business anywhere near
what was coming next. Small they were, and defenseless; a speedster's
screens were as efficacious as so much vacuum against the forces about
to be unleashed. The powerhouses also moved. Maintaining rigidly their
cryptic mathematical relationships to each other and the Sun, they went
as a whole into a new one with respect to the circling rings of tightly
packed meteors and the invisible, nonexistent mouth of the Boskonian
vortex.</p>
<p class="calibre3">Then, before Haynes' formation was nearly complete, the Boskonian fleet
materialized. Just that—one instant space was empty; the next it was
full of warships. A vast globe of battle wagons, in perfect fighting
formation. They were not free, but inert and deadly.</p>
<p class="calibre3">Haynes swore viciously under his breath, the Lensmen pulled themselves
together more tensely; but no additional orders were given. Everything
that could possibly be done was already being done.</p>
<p class="calibre3">Whether the Boskonians expected to meet a perfectly placed fleet or
whether they expected to emerge into empty space, to descend upon a
defenseless Tellus, is not known or knowable. It is certain, however,
that they emerged in the best possible formation to meet anything that
could be brought to bear. It is also certain that, had the enemy had a
<i class="calibre9">Z9M9Z</i> and a Kinnison-Worsel-Tregonsee combination scanning its
Operations tank, the outcome might well have been otherwise than it was.</p>
<p class="calibre3">For that ordinarily insignificant delay, that few minutes of time
necessary for the Boskonians' orientation, was exactly that required
for these two hundred smoothly working Rigellians to get Civilization's
shock globe into position.</p>
<div class="figcenter3" id="illus3">
<img alt="" class="w" id="id-2728984223436471585" src="Images/img0011.jpg"/>
</div>
<p class="calibre3">A million beams, primaries raised to the hellish heights possible
only to Medonian conductors and insulation, lashed out almost as one.
Screens stiffened to the urge of every generable watt of defensive
power. Bolt after bolt of quasi-solid lightning struck and struck and
struck again. Q-type helices bored, gouged and searingly hit. Rods and
cones, planes and shears of incredibly condensed pure force clawed,
tore and ground in mad abandon. Torpedo after torpedo, charged to the
very skin with duodec, loosed its horribly detonant cargo against
flinching wall shields, in such numbers and with such violence as to
fill all circumambient space with an atmosphere of almost planetary
density.</p>
<p class="calibre3">Screen after screen, wall shield after wall shield, in their hundreds
and their thousands, went down. A full eighth of the Patrol's entire
count of battleships were wrecked, riddled, blown apart or blasted
completely out of space in the paralyzingly cataclysmic violence of
that first, seconds-long, mind-shaking, space-racking encounter. Nor
could it have been otherwise; for this encounter had not been at battle
range. Not even at point-blank range; the warring monsters of the void
were packed practically screen to screen.</p>
<p class="calibre3">But not a man died—upon Civilization's side at least—even though
practically all of the myriad of ships composing the inner sphere,
the shock globe, was lost. For they were automatic; manned by robots;
what little superintendence was necessary had been furnished by remote
control. Indeed it is possible, although perhaps not entirely probable,
that the shock globe of the foe was similarly manned.</p>
<p class="calibre3">That first frightful meeting gave time for the reserves of the Patrol
to get there, and it was then that the superior Operations control of
the <i class="calibre9">Z9M9Z</i> made itself tellingly felt. Ship for ship, beam for
beam, screen for screen, the Boskonians were, perhaps, equal to the
Patrol; but they did not have the perfection of control necessary for
unified action. The field was too immense, the number of contending
units too enormously vast. But the mind of each of the three Unattached
Lensmen read aright the flashing lights of his particular volume of the
gigantic tank and spread their meaning truly in the infinitely smaller
space model beside which Admiral Haynes, master tactician, stood.
Scanning the entire space of battle as a whole, he rapped out general
orders—orders applying, perhaps, to a hundred or to five hundred
planetary fleets. Kinnison and his fellows broke these orders down for
the operators, who in turn told the vice admirals and rear admirals
of the fleets what to do. They gave detailed orders to the units of
their commands, and the line officers, knowing exactly what to do and
precisely how to do it, did it with neatness and dispatch.</p>
<p class="calibre3">There was no doubt, no uncertainty, no indecision or wavering. The line
officers, even the rear and vice admirals, knew nothing, could know
nothing whatever of the progress of the engagement as a whole. But they
had worked under the <i class="calibre9">Z9M9Z</i> before. They knew that the maestro
Haynes did know the battle as a whole. They knew that he was handling
them as carefully and as skillfully as a master at chess plays his
pieces upon the square-filled board. They knew that Kinnison or Worsel
or Tregonsee was assigning no task too difficult of accomplishment.
They knew that they could not be taken by surprise, attacked from some
unexpected and unprotected direction; knew that, although in those
hundreds of thousands of cubic miles of space there were hundreds of
thousands of highly inimical and exceedingly powerful ships of war,
none of them were, or shortly could be, in position to do them serious
harm. If there had been, they would have been pulled out of there,
<i class="calibre9">beaucoup</i> fast. They were as safe as anyone in a warship in
such a war could expect, or even hope, to be. Therefore they acted
instantly; directly, whole-heartedly and efficiently; and it was the
Boskonians who were taken, repeatedly and by the thousands, by surprise.</p>
<p class="calibre3">For the enemy, as has been said, did not have the Patrol's smooth
perfection of control. Thus several of Civilization's fleets, acting in
full synchronizing, could and repeatedly did rush upon one unit of the
foe; inglobing it, blasting it out of existence, and dashing back to
stations; all before the nearest-by fleets of Boskone knew even that a
threat was being made. Thus ended the second phase of the battle, the
engagement of the two Grand Fleets, with the few remaining thousands of
Boskone's battleships taking refuge upon or near the phalanx of planets
which had made up their center.</p>
<p class="calibre3">Planets. Seven of them. Armed and powered as only a planet can be armed
and powered; with fixed-mount weapons impossible of mounting upon any
lesser mobile base, with fixed-mount intakes and generators which only
planetary resources could excite or feed. Galactic Civilization's war
vessels fell back. Attacking a full-armed planet was no part of their
job. And as they fell back, the supermaulers moved ponderously up and
went to work. This was their dish; for this they had been designed.
Tubes, lances, stilettos of unthinkable energies raved against their
mighty screens; bouncing off, glancing away, dissipating themselves
in space-torturing discharges as they hurled themselves upon the
nearest ground. In and in the monsters bored, inexorably taking
up their positions directly over the ultra-protected domes which,
their commanders knew, sheltered the vitally important Bergenholms
and controls. Then they loosed forces of their own. Forces of such
appalling magnitude as to burn out in the twinkling of an eye projector
shells of a refractoriness to withstand for ten full seconds the
maximum output of a first-class battleship's primary batteries!</p>
<p class="calibre3">The resultant beam was of very short duration, but of utterly
intolerable poignancy. No material substance could endure it even
momentarily. It pierced instantly the hardest, tightest wall shield
known to the scientists of the Patrol. It was the only known thing
which could cut or rupture the ultimately stubborn fabric of a Q-type
helix. Hence it is not to be wondered at that as those incredible
needles of ravening energy stabbed and stabbed and stabbed again at
Boskonian domes every man of the Patrol, even Kimball Kinnison, fully
expected those domes to go down.</p>
<p class="calibre3">But those domes held. And those fixed-mount projectors hurled back
against the supermaulers forces at the impact of which course after
course of fierce-driven defensive screen flamed through the spectrum
and went down.</p>
<p class="calibre3">"Back! Get them back!" Kinnison whispered, white-lipped, and the
attacking structures sullenly, stubbornly gave way.</p>
<p class="calibre3">"Why?" gritted Haynes. "They're all we've got."</p>
<p class="calibre3">"You forget the new one, chief—give us a chance."</p>
<p class="calibre3">"What makes you think it'll work?" the old admiral flashed the searing
thought. "It probably won't—and if it doesn't—"</p>
<p class="calibre3">"If it doesn't," the younger man shot back, "we're no worse off than
now to use the maulers. But we've got to use the sunbeam <i class="calibre9">now</i>
while those planets are together and before they start toward Tellus."</p>
<p class="calibre3">"QX," the admiral assented; and, as soon as the Patrol's maulers were
out of the way:</p>
<p class="calibre3">"Verne?" Kinnison flashed a thought. "We can't crack 'em. Looks like
it's up to you—what do you say?"</p>
<p class="calibre3">"Jury-rigged—don't know whether she'll light a cigarette or not—but
here she comes!"</p>
<p class="calibre3">The sun, shining so brightly, darkened almost to the point of
invisibility. The war vessels of the enemy disappeared, each puffing
out into a tiny, but brilliant, sparkle of light.</p>
<p class="calibre3">Then, before the beam could affect the enormous masses
of the planets, the engineers lost it. The sun flashed
up—dulled—brightened—darkened—wavered. The beam waxed and waned
irregularly; the planets began to move away under the urgings of their
now thoroughly scared commanders.</p>
<p class="calibre3">Again, while millions upon millions of tensely straining Patrol
officers stared into their plates, haggard Thorndyke and his sweating
crews got the sunbeam under control again—and, in a heart-stoppingly
wavering fashion, held it together. It flared—sputtered—ballooned
out—but very shortly, before they could get out of its way, the
planets began to glow. Ice caps melted, then boiled. Oceans boiled,
their surfaces almost exploding into steam. Mountain ranges melted and
flowed sluggishly down into valleys. The Boskonian domes of force went
down and stayed down.</p>
<p class="calibre3">"QX, Kim—let be," Haynes ordered. "No use overdoing it. Not
bad-looking planets; maybe we can use them for something."</p>
<p class="calibre3">The sun brightened to its wonted splendor, the planets began visibly to
cool—even the Titanic forces then at work had heated those planetary
masses only superficially.</p>
<p class="calibre3">The battle was over.</p>
<p class="calibre3">"What in all the purple hells of Palain did you do, Haynes, and how?"
demanded the <i class="calibre9">Z9M9Z's</i> captain.</p>
<p class="calibre3">"He used the whole damned solar system as a vacuum tube!" Haynes
explained, gleefully. "Those power stations out there, with all their
motors and intake screens, are simply the power leads. The asteroid
belts, and maybe some of the planets, are the grids and plates. The sun
is—"</p>
<p class="calibre3">"Hold on, chief!" Kinnison broke in. "That isn't quite it. You see, the
directive field set up by the—"</p>
<p class="calibre3">"Hold on yourself!" Haynes ordered, brusquely. "You're too damned
scientific, just like Sawbones Lacy. What do Rex and I care about
technical details that we can't understand, anyway? The net result is
what counts—and that was to concentrate upon those planets practically
the whole energy output of the Sun. Wasn't it?"</p>
<p class="calibre3">"Well, that's the main idea," Kinnison conceded. "The energy
equivalent, roughly, of four million one hundred and fifty thousand
tons per second of disintegrating matter."</p>
<p class="calibre3">"<i class="calibre9">Whew!</i>" the captain whistled. "No wonder it frizzled 'em up."</p>
<p class="calibre3">"I can say now, I think, with no fear of successful contradiction, that
Tellus <i class="calibre9">is</i> strongly held," Haynes stated, with conviction. "What
now, Kim, old son?"</p>
<p class="calibre3">"I think they're done, for a while," the Gray Lensman pondered.
"Cardynge can't communicate through the tube, so probably they can't;
but if they managed to slip an observer through, they may know how
almighty close they came to licking us. On the other hand, Verne says
that he can get the bugs out of the sunbeam in a couple of weeks—and
when he does, the next zwilnik he cuts loose at is going to get a
surprise."</p>
<p class="calibre3">"I'll say so," Haynes agreed. "We'll keep the surveyors on the prowl,
and some of the Fleet will always be close by. Not all of it, of
course—we'll adopt a schedule of reliefs—but enough of it to be
useful. That ought to be enough, don't you think?"</p>
<p class="calibre3">"I think so—yes," Kinnison answered, thoughtfully. "I'm just about
positive that they won't be in shape to start anything here again for a
long time. And I had better get busy, sir, on my own job—I've got to
put out a few jets."</p>
<p class="calibre3">"I suppose so," Haynes admitted.</p>
<p class="calibre3">For Tellus <i class="calibre9">was</i> strongly held, now—so strongly held that
Kinnison felt free to begin again the search upon whose successful
conclusion depended, perhaps, the outcome of the struggle between
Boskonia and Galactic Civilization.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0004.vue?60c68ce5